import { render, staticRenderFns } from "./ListAreaItems.vue?vue&type=template&id=2a44afe0&scoped=true"
import script from "./ListAreaItems.vue?vue&type=script&lang=js"
export * from "./ListAreaItems.vue?vue&type=script&lang=js"
import style0 from "./ListAreaItems.vue?vue&type=style&index=0&id=2a44afe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44afe0",
  null
  
)

export default component.exports